export enum OverrideType {
    Bulk = 'bulk',
    Single = 'single'
}

export enum StatusType {
    Active = 'Active',
    NeedsApproval = 'Needs Approval',
    New = 'New',
    OverrideIgnore = 'Override Ignore',
    OverrideWatch = 'Override Watch',
    UserFlag = 'User Flag',
    Approve = 'Approved',
    ReOptimized = 'Re-Optimized',
    AutopilotOff = 'Autopilot Off',
    // Display-only state derived in the component from OTB vs allocation; the API
    // never sends this value and it is absent from the Record Status filter, which
    // is populated from /dim_lookup/status_types. See InventoryComponent.isSoldOut.
    SoldOut = 'Sold Out'
}

export enum BusinessRuleIndicator {
    Active = 'Active',
    Pending = 'Pending',
    // Display-only state derived in the component from businessRuleSuppressed; the API
    // never sends this value. See InventoryComponent.getBusinessRuleState (RLP-4261).
    Suppressed = 'Suppressed'
}
